export class Administration {
    id = '';
    description = '';

    deserialize(data: any) {
        this.id = data.ID ?? '';
        this.description = data.Name ?? '';
        return this;
    }

    static Sort(a1: Administration, a2: Administration) {
        return a1.description.localeCompare(a2.description);
    }
}
